import { Modal, Button } from 'react-bootstrap';

/**
 * ChallengeModal — shown when the current player initiates a challenge,
 * or when a play-out scenario requires the current player to decide whether
 * to challenge the played-out player's last words.
 *
 * Props:
 *   show               {boolean}   — whether the modal is visible
 *   words              {string[]}  — words formed by the previous player's turn
 *   challengedPlayerName {string}  — name of the player being challenged
 *   onChallenge        {function}  — called when Confirm Challenge is pressed
 *   onCancel           {function}  — called when Cancel is pressed (normal challenge)
 *   pendingPlayOut     {boolean}   — true when this is a play-out challenge decision
 *   onAcknowledge      {function}  — called when "Don't Challenge" pressed during play-out
 */
const ChallengeModal = ({ show, words = [], challengedPlayerName, onChallenge, onCancel, pendingPlayOut = false, onAcknowledge = null }) => {
    const handleDismiss = pendingPlayOut ? onAcknowledge : onCancel;
    return (
        <Modal show={show} onHide={handleDismiss} centered>
            <Modal.Header closeButton>
                <Modal.Title>
                    {pendingPlayOut ? "Challenge Play-Out?" : `Challenge ${challengedPlayerName}?`}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p>
                    The following {words.length === 1 ? 'word was' : 'words were'} played
                    by <strong>{challengedPlayerName}</strong>:
                </p>
                <ul>
                    {words.map((word, i) => (
                        <li key={i} style={{ fontWeight: 'bold', textTransform: 'uppercase' }}>
                            {word}
                        </li>
                    ))}
                </ul>
                <p className="text-muted" style={{ fontSize: '0.9em' }}>
                    {pendingPlayOut
                        ? `${challengedPlayerName} has played their last tile. If any word is illegal the challenge succeeds — tiles are returned and the game continues. If all words are valid, the game ends with play-out scoring.`
                        : `If any word is not in the dictionary, the challenge succeeds: tiles are returned and the score is forfeited. If all words are valid, you forfeit your turn.`}
                </p>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleDismiss}>
                    {pendingPlayOut ? "Don't Challenge" : "Cancel"}
                </Button>
                <Button variant="danger" onClick={onChallenge}>
                    Confirm Challenge
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default ChallengeModal;
